import scrollInvalidControlIntoView from '../../util/scrollInvalidControlIntoView';

$(() => {
  const $form = $('[data-js-waiver-form]');
  const selectors = {
    container: '[data-js-registrant-waiver]',
    scrollContainer: '[data-js-waiver-scroll-container]',
    forceScrollText: '[data-js-force-scroll-text]',
    signOffControls: '[data-js-sign-off-controls]',
    liveRegion: '[data-js-waiver-live-region]',
    submitHelp: '[data-js-waiver-submit-help]',
    submitButton: 'button[type="submit"]',
    signOffAcceptInput: ':input[name*="acceptance"]',
    signOffSignatureInputContainer: '[data-js-sign-off-signature-input-container]',
    signOffSignatureInput: ':input[name*="signature"]',
  };

  function buildAnnouncement(messages) {
    let announcement = '';

    for (const message of messages) {
      if (!message) {
        continue;
      }

      announcement = announcement ? `${announcement} ${message}` : message;
    }

    return announcement;
  }

  function announce(message) {
    const $liveRegion = $form.find(selectors.liveRegion);
    if (!$liveRegion.length || !message) {
      return;
    }

    $liveRegion.text('');

    // Separate DOM updates so assistive tech treats this as a new announcement.
    window.requestAnimationFrame(() => {
      $liveRegion.text(message);
    });
  }

  function setSubmitButtonDisabled(isDisabled) {
    $form.find(selectors.submitHelp).attr('aria-hidden', isDisabled ? 'false' : 'true');

    $form.find(selectors.submitButton)
      .toggleClass('disabled', isDisabled)
      .prop('disabled', isDisabled)
      .attr('aria-describedby', isDisabled ? 'waiver-submit-help' : null);
  }

  /**
   * Lots of ifs, ands, and buts to see if the waiver requirements are met.
   * @returns {boolean}
   */
  function checkIfWaiverRequirementsAreMet() {
    let conditionsMet = true;
    $form
      .find(selectors.container)
      .each((index, element) => {
        const $errorContainer = $(element).find(selectors.forceScrollText);
        if ($errorContainer.length && $errorContainer.data('validate') === false) {
          conditionsMet = false;
          return false;
        }

        return true;
      });

    setSubmitButtonDisabled(!conditionsMet);

    return conditionsMet;
  }

  function unlockSignOffControls($container) {
    const $forceScrollText = $container.find(selectors.forceScrollText);
    const $signOffControls = $container.find(selectors.signOffControls);

    if (!$forceScrollText.length || $forceScrollText.data('validate') === true) {
      return;
    }

    $forceScrollText.addClass('hidden').data('validate', true);
    $signOffControls.removeClass('hidden').attr('aria-hidden', 'false');

    const areWaiverRequirementsMet = checkIfWaiverRequirementsAreMet();
    const announcement = areWaiverRequirementsMet
      ? buildAnnouncement([
        $container.data('signOffAvailableAnnouncement'),
        $form.data('continueEnabledAnnouncement'),
      ])
      : $container.data('signOffAvailableAnnouncement');

    announce(announcement);
  }

  /**
   * True when the waiver text already fits in the scroll box (1px for subpixel rounding).
   *
   * @param {HTMLElement} el
   * @returns {boolean}
   */
  function contentFitsWithoutScroll(el) {
    return el.scrollHeight <= el.clientHeight + 1;
  }

  /**
   * Unlock sign-off when content fits; otherwise keep the box keyboard-focusable.
   *
   * @param {JQuery} $container
   * @param {JQuery} $scrollContainer
   */
  function unlockIfContentFits($container, $scrollContainer) {
    if (contentFitsWithoutScroll($scrollContainer[0])) {
      unlockSignOffControls($container);
      return;
    }

    $scrollContainer.attr('tabindex', 0);
  }

  /**
   * Handle the scroll event of waiver container
   *
   * @param $container
   */
  function handleScrollContainer($container) {
    const $scrollContainer = $container.find(selectors.scrollContainer);
    const el = $scrollContainer[0];

    if (!el) {
      return;
    }

    unlockIfContentFits($container, $scrollContainer);

    $scrollContainer.on('scroll', (event) => {
      const $this = $(event.target);
      const scrollPercentage = ((($this.scrollTop() + $this.innerHeight()) / $this[0].scrollHeight) * 100)
        .toFixed(2);
      if (scrollPercentage >= 99) {
        unlockSignOffControls($container);
      }
    });

    window.addEventListener('load', () => {
      unlockIfContentFits($container, $scrollContainer);
    });

    if (typeof ResizeObserver === 'function') {
      const resizeObserver = new ResizeObserver(() => {
        unlockIfContentFits($container, $scrollContainer);
      });
      resizeObserver.observe(el);
    }
  }

  /**
   * Toggle the signature input container based on selected accept option
   *
   * @param event
   */
  function toggleSignatureInputContainer(event) {
    const $this = $(event.currentTarget);
    const $signOffControls = $this.closest(selectors.signOffControls);
    const $signatureInputContainer = $signOffControls.find(selectors.signOffSignatureInputContainer);

    if (parseInt($this.val(), 10) === 1) {
      $signatureInputContainer.removeClass('hidden').find(selectors.signOffSignatureInput).attr('required', true);
    } else {
      $signatureInputContainer.addClass('hidden').find(selectors.signOffSignatureInput).attr('required', false);
    }
  }

  /**
   * Tell Google that the waiver was accepted
   */
  const submit = (event) => {
    if (!event.currentTarget.checkValidity()) {
      return;
    }

    window.dataLayer.push({
      event: 'waiver_accepted',
    });
  };

  /**
   * Initialize listeners and properties
   */
  function initialize() {
    if (!$form.length) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    $form.find(selectors.container).each((index, element) => handleScrollContainer($(element)));
    $form.on('submit', submit);
    $(selectors.signOffAcceptInput).on('change', toggleSignatureInputContainer);

    const waiverForm = $form[0];
    if (waiverForm) {
      let scrollHandledForInvalidBurst = false;

      waiverForm.addEventListener('invalid', (event) => {
        if (scrollHandledForInvalidBurst) {
          return;
        }

        scrollHandledForInvalidBurst = true;
        scrollInvalidControlIntoView(event.target);
        queueMicrotask(() => {
          scrollHandledForInvalidBurst = false;
        });
      }, true);
    }

    checkIfWaiverRequirementsAreMet();
  }

  initialize();
});
